import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PreparationHDModel } from '../models/PreparationHDModel';
import { LocalStorageService } from 'ngx-webstorage';
import { URLsConfig } from '../URLsConfig';


@Injectable()
export class PreparationHDService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }


    public getPrepHD(docNumber: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("docNumber", docNumber);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<PreparationHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/GetPreparationHD',options);
    }

    public AddPrepHD(PrepHD: PreparationHDModel) {
      return this.http.post<PreparationHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/AddPreparationHD', PrepHD);
  }
  public DelPrepHD(docNumber: string , compCode: string) {
    let params = new HttpParams();
    params = params.append("docNumber", docNumber);
    params = params.append("compCode", compCode);


    const options = {
      params: params
  };

  return this.http.get<PreparationHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/DeletePreparationHD',options);
}
  public getSerialHD(compCode: string) {
    let params = new HttpParams();

      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<PreparationHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/GetPreparationSerial',options);
  }

  public getPrepHDLookup(docNumber: string, paIntCode: string,patientFName:string, compCode: string) {
    let params = new HttpParams();
    params = params.append("docNumber", docNumber);
    params = params.append("paIntCode", paIntCode);
    params = params.append("patientFName", patientFName);
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<PreparationHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/PreparationLookup', options);
}

  public getPrepHDLookupTop(compCode: string) {
    let params = new HttpParams();
    params = params.append("CompCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<PreparationHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/PreparationLookupTop', options);
}
public getPreviousPrepHDLookupTop(paintcode :string ,compCode: string) {
  let params = new HttpParams();
  params = params.append("paintcode", paintcode);
  params = params.append("CompCode", compCode);
  const options = {
      params: params
  };
  return this.http.get<PreparationHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Preparation/PreviousPreparationLookupTop', options);
}
  }
